import { useInViewEvent } from '@spotahome/ui-library/src/tenant/components/withInViewEvent';

import { useSoyuzExperiment } from '@spotahome/soyuz/client';

import Paginator from './Paginator';
import NewPaginator from './NewPaginator';

export const PaginatorExperimentWrapper = props => {
  const isNewPaginatorExperiment =
    useSoyuzExperiment('NewPaginator').get('behaviour') === 'variant';
  const ref = useInViewEvent('Paginator');

  return (
    <div ref={ref}>
      {isNewPaginatorExperiment ? (
        <NewPaginator {...props} />
      ) : (
        <Paginator {...props} />
      )}
    </div>
  );
};

export default Paginator;
